import { AIChatDto } from "../../model/chat-wiget/dto/AIChatDto";
import { AIChatResponseDto } from "../../model/chat-wiget/dto/AIChatResponseDto";
import { AtiraApi } from "../AxiosClient";

export class ChatWidgetAxios {
  static chatAI(dto: AIChatDto) {
    return AtiraApi.post<AIChatResponseDto>("/plugin/chat/ai", dto).then(
      ({ data }) => data,
    );
  }
}
